var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.36951",
      "apollo-dlb": "static-3.73",
      "client-types": "static-1.421",
      "codemirror-dlb": "static-1.57263",
      "collaboration-sidebar": "static-1.56455",
      "ContentComponents": "static-2.69719",
      "ContentData": "static-1.66838",
      "ContentEditorUI": "static-2.75704",
      "ContentUtils": "static-1.66763",
      "customer-agent-datasources-lib": "static-1.5490",
      "customer-agent-discovery-components-lib": "static-1.1698",
      "customer-agent-forms": "static-1.3484",
      "data-fetching-client": "static-1.9124",
      "editor-components": "static-1.12528",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.37682",
      "foundations-assets": "static-1.4301",
      "foundations-components": "static-1.6982",
      "head-dlb": "static-1.4465",
      "hs-test-utils": "static-1.7431",
      "hub-http": "static-1.5499",
      "hub-http-shared-msw-handlers": "static-1.8699",
      "hubspot-dlb": "static-2.1707",
      "HubStyleTokens": "static-2.10954",
      "I18n": "static-7.1469",
      "InpageEditorUI": "static-1.84144",
      "jasmine-immutable": "static-1.2417",
      "jasmine-runner": "static-1.5854",
      "layout-dnd-utils": "static-1.10466",
      "personalization-lib": "static-1.5896",
      "quartz": "static-1.6256",
      "react-dlb": "static-1.64",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.16",
      "react-router-dom": "static-5.26",
      "react-utils": "static-2.4847",
      "redux-thunk": "static-2.43",
      "settings-ui-lib": "static-1.11965",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4377",
      "ui-components-test-utils": "static-1.5092",
      "ui-images": "static-2.983",
      "ui-memberships-settings-lib": "static-1.32588",
      "video-components-external": "static-1.9775",
      "webpack-env": "static-1.54",
      "ai-components-ui-library": "static-1.7557",
      "amplitude-session-replay-browser": "static-1.49",
      "apollo-stack-hubspot": "static-3.69",
      "asset-actions-lib": "static-1.44669",
      "atom": "static-1.4575",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.25679",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.7093",
      "content-label-lib": "static-1.6180",
      "content-management-actions-lib": "static-1.26247",
      "content-management-data-lib": "static-1.4657",
      "content-management-restrictions-lib": "static-1.4431",
      "copilot-plugins": "static-1.9691",
      "copilot-toolkit": "static-1.9718",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.621",
      "cta-picker": "static-1.35149",
      "customer-data-objects": "static-1.7101",
      "customer-data-objects-ui-components": "static-1.12453",
      "customer-data-properties": "static-1.49882",
      "customer-data-property-utils": "static-1.7440",
      "customer-data-reference-ui-components": "static-1.12540",
      "customer-data-ui-utilities": "static-1.9215",
      "data-token-picker": "static-1.15533",
      "data-token-views": "static-1.15514",
      "error-messaging-js": "static-1.4698",
      "feedback-loader": "static-1.28231",
      "file-manager-components": "static-1.22042",
      "FileManagerCore": "static-1.37541",
      "FormsCommonComponents": "static-1.84513",
      "foundations-theming": "static-1.3809",
      "fuzzy": "static-1.8",
      "growth-onboarding-beacon": "static-1.4316",
      "growth-onboarding-confetti": "static-1.2504",
      "growth-onboarding-next-action-components": "static-1.924",
      "growth-payments-core": "static-1.23901",
      "history": "static-4.47",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4969",
      "hub-http-contrib": "static-1.2546",
      "hubspot-url-utils": "static-1.3531",
      "HubStyle": "static-2.11262",
      "icons": "static-2.599",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "InboxConnectUtils": "static-4.13468",
      "integrations-lib": "static-1.14573",
      "interframe": "static-3.4196",
      "laboratory-lib": "static-3.6612",
      "layout-data-lib": "static-1.8791",
      "media-bridge-lib": "static-1.18090",
      "nav-meta": "static-1.28132",
      "object-builder-ui-client": "static-1.47042",
      "onboarding-scopes": "static-1.5961",
      "onboarding-tours": "static-1.15874",
      "onboarding-tours-client": "static-1.4088",
      "outpost": "static-1.3741",
      "page-lib": "static-1.20965",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.22207",
      "payments-post-enroll-local-storage-lib": "static-1.4488",
      "pictos": "static-7.173",
      "PortalIdParser": "static-2.319",
      "products-ui-components": "static-1.38491",
      "property-translator": "static-1.4817",
      "quick-fetch": "static-1.3468",
      "raven": "static-3.5386",
      "react": "static-7.151",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.9684",
      "react-dom": "static-7.85",
      "react-flip-move": "static-1.59",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.16100",
      "react-select-plus": "static-1.65",
      "react-tinymce": "static-1.53816",
      "react-transition-group": "static-1.7",
      "react-virtualized": "static-2.86",
      "redux": "static-4.16",
      "redux-request-state": "static-1.10030",
      "reference-resolvers": "static-1.7658",
      "reference-resolvers-lite": "static-1.7524",
      "reselect": "static-2.16",
      "rich-text-lib": "static-1.18870",
      "rpc-client-utils": "static-1.4136",
      "sanitize": "static-1.3854",
      "sanitize-text": "static-1.7602",
      "seamless-immutable": "static-7.6",
      "self-service-api": "static-1.9687",
      "SharedI18nStrings": "static-1.175",
      "SharedLegalStrings": "static-1.1390",
      "simple-menus-core": "static-1.14310",
      "simple-menus-lib": "static-1.15827",
      "smart-content-lib": "static-1.41706",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.478",
      "superstore": "static-1.4178",
      "theme-previewer-lib": "static-1.51893",
      "tinymce-config": "static-2.52942",
      "tinymce-copilot": "static-1.15010",
      "tinymce-data": "static-1.39027",
      "tinymce-plugins": "static-1.56056",
      "tinymce-themes": "static-1.54912",
      "transmute": "static-2.77",
      "ui-addon-emoji-picker": "static-1.9376",
      "ui-addon-form-validation": "static-1.10474",
      "ui-addon-i18n": "static-1.10469",
      "ui-addon-iframeable": "static-1.8367",
      "ui-addon-opt": "static-4.7928",
      "ui-addon-sales-email": "static-1.4680",
      "ui-addon-upgrades": "static-9.17103",
      "ui-business-units-lib": "static-1.8395",
      "ui-gdpr-components": "static-1.9709",
      "ui-product-approvals": "static-1.26602",
      "ui-shepherd-react": "static-3.9527",
      "ui-suspension-banners-lib": "static-1.5816",
      "UIComponents": "static-3.7901",
      "underscore": "static-1.8",
      "urlinator": "static-1.3991",
      "usage-tracker": "static-1.6851",
      "usage-tracker-core": "static-1.6701",
      "usage-tracker-session-replay": "static-1.4537",
      "user-context": "static-1.4609",
      "video-embed": "static-1.34267",
      "web-interactives-components": "static-1.12925",
      "web-interactives-data": "static-1.12926",
      "wootric-nps": "static-1.6369",
      "xray-recommendation-lib": "static-1.7096",
      "codemirror": "static-5.84",
      "react-codemirror": "static-1.10085",
      "enviro": "static-4.345",
      "hs-promise-rejection-tracking": "static-1.4918",
      "raven-hubspot": "static-1.5693",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.9058",
      "bend-plugin-trellis-migration": "static-1.2957",
      "moment": "static-3.26",
      "chatspot-client-types": "static-1.10149",
      "chatspot-core": "static-1.19279",
      "chatspot-widget-iframe": "static-1.19271",
      "collaboration-sidebar-common": "static-1.1251",
      "framework-data-schema-resolvers": "static-1.6314",
      "frontend-preferences-client": "static-1.7408",
      "magpie-lib": "static-1.5080",
      "magpie-types": "static-1.4540",
      "quartz-core": "static-1.5475",
      "simple-logging-lib": "static-1.2431",
      "ts-schema": "static-1.3612",
      "advanced-menus-core": "static-1.14311",
      "advanced-menus-lib": "static-1.11347",
      "avatar-components": "static-1.1955",
      "cms-field-types": "static-1.4172",
      "content-embed-lib": "static-1.6829",
      "ExportDialog": "static-6.9913",
      "forms-utils-lib": "static-1.11535",
      "integrations-error-boundary-lib": "static-1.11988",
      "payments-embed-points-lib": "static-1.11887",
      "products-iframe-lib": "static-1.6534",
      "react-dnd-compat": "static-1.4097",
      "usage-tracker-container": "static-1.6841",
      "video-data-lib": "static-1.33433",
      "videoconference-integration-components": "static-1.6043",
      "graphql": "static-1.71",
      "quartz-config": "static-1.34",
      "backbone": "static-1.6",
      "editor-iframe-lib": "static-1.7788",
      "FireAlarmUi": "static-1.4083",
      "hubspot-apollo-client": "static-1.4269",
      "layout-dnd-components": "static-1.11491",
      "marketing-email-service-types": "static-1.1636",
      "smart-content-core": "static-1.41054",
      "social-composer-lib": "static-1.56992",
      "structured-content-lib": "static-1.23919",
      "timezone-utils": "static-2.4636",
      "ui-active-theme-content-creator-lib": "static-1.36731",
      "ui-addon-video-player": "static-1.8213",
      "ui-asset-management-lib": "static-1.10204",
      "ui-brand-identity-lib": "static-1.12597",
      "ui-tool-access": "static-1.9522",
      "content-icons-ui": "static-1.2036",
      "conversations-skeleton-state": "static-1.6785",
      "final-form": "static-1.58",
      "hubspot-prosemirror": "static-1.16817",
      "prosemirror": "static-1.13",
      "foundations-theming-specialty": "static-1.1525",
      "directed-graph": "static-1.363",
      "event-emitter": "static-1.433",
      "fast-json-stable-stringify": "static-1.4",
      "react-aria": "static-1.44",
      "audio-components": "static-1.5259",
      "FileManagerImages": "static-1.35193",
      "video-components": "static-1.11778",
      "hs-story-utils": "static-1.8814",
      "bend-plugin-foundations-components": "static-1.3251",
      "floating-ui": "static-1.45",
      "framer-motion": "static-1.57",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.335",
      "HeadJS": "static-2.635",
      "hs-test-utils-bend-plugin": "static-1.2542",
      "msw": "static-1.39",
      "testing-library": "static-1.139",
      "i18n-data": "static-1.211",
      "moment-timezone": "static-5.72",
      "jquery": "static-3.6",
      "NamespacedHubStyle": "static-2.8664",
      "react-dnd-ipeui-backend": "static-1.1474",
      "ui-coaching-tips": "static-1.27107",
      "jasmine": "static-4.3734",
      "marketplace-embed": "static-1.20687",
      "ui-addon-react-router-dom": "static-1.9029",
      "quartz-core-utils": "static-1.3123",
      "flux-actions": "static-1.290",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9908",
      "rxjs": "static-5.10",
      "foundations-components-test-utils": "static-1.4466",
      "apollo-link-hub-http": "static-2.4175",
      "content-media-composition-data-lib": "static-1.10137",
      "content-media-compositions": "static-2.14144",
      "idb-keyval": "static-1.33",
      "immerable": "static-1.3554",
      "autolinker": "static-3.11",
      "foundations-theming-base": "static-1.2794",
      "sassPrefix": "static-1.145",
      "marketing-platform-lib": "static-1.6221",
      "attribution-lib": "static-1.41013",
      "crm-message-bus": "static-1.41582",
      "crm-pipelines-api-client-types": "static-1.3562",
      "nudge-client-utils": "static-1.1751",
      "reporting-ui-components": "static-2.62642",
      "hubspotter-http": "static-1.4079",
      "ai-rendering-library": "static-1.8434",
      "inbound-db-properties-service-client": "static-1.3445",
      "calling-global-api": "static-1.62730",
      "calling-internal-common": "static-1.30787",
      "calling-lifecycle-internal": "static-1.64112",
      "calling-lifecycle-messages": "static-1.56406",
      "commerce-products-lib": "static-1.7972",
      "conditional-properties-service-client": "static-1.3382",
      "crm-links": "static-1.5665",
      "external-options-client-types": "static-1.3601",
      "google-libphonenumber": "static-1.26",
      "inbound-db-meta-service-client": "static-1.3221",
      "inbounddb-objects-service-types": "static-1.3688",
      "multi-currency-client-types": "static-1.3218",
      "pipeline-validation-client-types": "static-1.3400",
      "property-value-citations": "static-1.496",
      "smart-property-lib": "static-1.4809",
      "tiered-pricing": "static-1.387",
      "react-immutable-render-mixin": "static-1.9",
      "redux-toolkit": "static-1.7",
      "salesImages": "static-1.514",
      "forms-ai-lib": "static-1.3440",
      "bend-plugin-foundations-theming": "static-1.2292",
      "embedded-academy-lib": "static-1.12707",
      "growth-onboarding-feedback-components": "static-1.5927",
      "commerce-analytics-service-client": "static-1.3119",
      "integrations-tracking-lib": "static-1.5103",
      "native-integrations-shared-strings": "static-1.7251",
      "ui-universal-auth": "static-1.8331",
      "getting-started-shared-tasks": "static-1.17083",
      "growth-data-modal": "static-1.4742",
      "growth-onboarding-next-action-utils": "static-1.896",
      "navigation-components": "static-1.16495",
      "ui-shepherd-tracker": "static-1.6908",
      "commerce-tours-lib": "static-1.5239",
      "growth-onboarding-reliability": "static-1.4571",
      "sales-checkout-service-client": "static-1.3131",
      "commerce-shared-components-lib": "static-1.17113",
      "commerce-subscription-lib": "static-1.35678",
      "crm_components": "static-3.90338",
      "crm_data": "static-4.90338",
      "customer-data-filters-ui": "static-1.37881",
      "customer-data-tracking": "static-1.6331",
      "dispatcher": "static-1.125",
      "framework-data-table": "static-2.10727",
      "property-description-translator": "static-1.3266",
      "csstype": "static-1.50",
      "batch-promise": "static-1.1029",
      "growth-monetization-service-types": "static-1.4091",
      "merchandise-lib": "static-1.245",
      "commerce-tools-ui-lib": "static-1.9134",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "navigation-messaging": "static-1.5822",
      "feature-store-service-types": "static-1.4084",
      "upgrade-management-service-types": "static-1.4075",
      "getting-started-shared-tasks-store": "static-1.16201",
      "seo-tools-lib": "static-1.5895",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "bender-build-tools": "static-1.2623",
      "markdown-it": "static-1.6",
      "zustand": "static-1.51",
      "framework-builder-read-service-client": "static-1.3509",
      "framework-data-schema-quick-fetch": "static-1.6219",
      "persist-promise": "static-1.3186",
      "hub-http-janus": "static-1.712",
      "reactive-lib": "static-1.179",
      "general-store": "static-6.20",
      "hubspotter-http-shared-msw-handlers": "static-1.8697",
      "mobile-manifest-mixins": "static-1.408",
      "platform-navigation-bootstrap": "static-1.12001",
      "payments-enrollment-embed-lib": "static-1.20993",
      "knowledge-content-types": "static-1.8077",
      "social-insights-client-types": "static-1.20630",
      "marketplace-ui-client-types": "static-1.15564",
      "marketplace-ui-common": "static-1.18157",
      "marketplace-ui-details": "static-1.8054",
      "property-management-iframe": "static-1.11286",
      "trellis-ecosystem": "static-1.6121",
      "hls.js": "static-1.28",
      "js-cookie": "static-1.18",
      "FormUrlGenerator": "static-2.4154",
      "highcharts": "static-8.93",
      "report-customization-components": "static-1.11796",
      "reporting-action-components": "static-1.39888",
      "reporting-data": "static-1.65368",
      "reporting-enablement": "static-1.21181",
      "reporting-snowflake": "static-1.53988",
      "reporting-visualizations": "static-1.57445",
      "nudge-custom-function-registry": "static-1.1507",
      "nudge-renderer-utils": "static-1.1826",
      "whisper-core-api": "static-1.5180",
      "reporting-plugins": "static-1.9482",
      "reporting-reports": "static-1.65048",
      "highlight.js": "static-1.68",
      "ui-addon-teams": "static-1.20824",
      "calling-error-reporting": "static-1.30793",
      "shared-worker-versioning": "static-1.10516",
      "calling-usage-tracker": "static-1.5958",
      "calling-orchestration-shared-library": "static-1.33924",
      "products-ui-components-shared-msw-handlers": "static-1.9081",
      "location-customization-utils-lib": "static-1.7665",
      "breeze-intelligence-kit": "static-1.4833",
      "framework-data-schema-resolvers-shared-msw-handlers": "static-1.8782",
      "fsm": "static-1.3145",
      "policy-lib": "static-1.6218",
      "reference-resolvers-lite-shared-msw-handlers": "static-1.8845",
      "academy-common-lib": "static-1.12167",
      "universal-page-editor-lib": "static-1.2497",
      "customer-data-associations": "static-1.6702",
      "commerce-billing-lib": "static-1.17686",
      "crm_universal": "static-1.21265",
      "customer-data-content": "static-1.26253",
      "crm_schema": "static-3.90377",
      "customer-data-email": "static-1.17078",
      "customer-data-filters-ui-msw-helpers": "static-1.20315",
      "lodash": "static-4.7",
      "multi-account-reference-resolvers": "static-1.482",
      "reporting-datasets-permissions-lib": "static-1.12145",
      "deal-intel-decorators": "static-1.347",
      "tanstack-virtual": "static-1.19",
      "customer-data-rte": "static-1.31753",
      "cv-backend-services": "static-1.1380",
      "growth-onboarding-empty-states": "static-1.4972",
      "qrcode-generator": "static-1.57",
      "quotes-client-types": "static-1.36279",
      "trials-service-types": "static-1.3492",
      "platform-infra-nav-components": "static-1.7219",
      "marketplace-ui-apps-core": "static-1.16691",
      "stripe-embedded-components": "static-1.6637",
      "ai-settings-ui-library": "static-1.6881",
      "immutable-less": "static-1.4004",
      "react-window": "static-1.13",
      "ai-studio-lib": "static-1.10188",
      "developer-experience-shared-components": "static-1.9844",
      "marketplace-ui-reviews": "static-1.18114",
      "marketplace-ui-tracking": "static-1.12329",
      "ui-addon-integrations-directory-panel": "static-2.7477",
      "usage-based-billing-components-lib": "static-1.7252",
      "property-management-common": "static-1.3573",
      "storybook-react": "static-1.20",
      "trellis-story-utils": "static-1.3991",
      "dashboard-lib": "static-1.79505",
      "share-with-third-party-component-lib": "static-1.8148",
      "reporting-client-types": "static-1.2265",
      "data-quality-ui-library": "static-1.11598",
      "html-to-image": "static-1.42",
      "campaign-roi-lib": "static-1.7402",
      "calling-orchestration-schema": "static-1.34149",
      "sales-views-client-types": "static-1.3705",
      "crm-record-cards-service-types": "static-1.3149",
      "academy-service-client": "static-1.3096",
      "utility-belt": "static-1.1927",
      "SalesContentIndexUI": "static-3.8311",
      "sequences-lib": "static-1.7245",
      "deal-intel-utils": "static-1.351",
      "draft-content-plugins": "static-1.27130",
      "draft-convert": "static-2.31",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-plugins": "static-2.20736",
      "ui-extensibility-client-types": "static-1.3469",
      "stripe-connect-js": "static-1.43",
      "knowledge-box": "static-1.6294",
      "apps-service-types": "static-1.3421",
      "oauth-service-types": "static-1.3687",
      "subscription-experience-data-types": "static-1.14059",
      "crm-component-utils": "static-1.37736",
      "redux-actions": "static-3.7",
      "sales-templates-service-types-lib": "static-1.3688",
      "sequences-client-types-lib": "static-1.7102",
      "card-properties-lib": "static-1.42727",
      "crm-actions": "static-1.5665",
      "crm-cards-data": "static-1.569",
      "crm-cards-sdk": "static-1.42071",
      "customer-data-properties-shared-msw-handlers": "static-1.8026",
      "customer-data-sidebar": "static-2.44592",
      "enrichment-properties-lib": "static-1.13927",
      "crm-fe-perf": "static-1.22413",
      "card-payment-highlight-lib": "static-1.35723",
      "card-subscription-highlight-lib": "static-1.38101",
      "commerce-contract-lib": "static-1.10252",
      "invoices-highlight-card-lib": "static-1.53120",
      "orders-highlight-card-lib": "static-1.20241",
      "products-highlight-card-lib": "static-1.16256",
      "project-storage": "static-1.4109",
      "quotes-highlight-card-lib": "static-1.70193",
      "crm-source-interpretation-lib": "static-1.4749",
      "quotes-ui-lib": "static-1.78910",
      "accounting-integrations-ui-components": "static-1.6152",
      "invoices-ui-lib": "static-1.53136",
      "commerce-products-api": "static-1.1427",
      "SafeStorage": "static-1.3796",
      "invoices-iframe-lib": "static-1.55194",
      "quotes-modal-lib": "static-1.100867",
      "totals-ui-components": "static-1.22174",
      "commerce-totals-service-types": "static-1.3327"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.36951",
      "apollo-dlb": "/apollo-dlb/static-3.73",
      "client-types": "/client-types/static-1.421",
      "codemirror-dlb": "/codemirror-dlb/static-1.57263",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.56455",
      "ContentComponents": "/ContentComponents/static-2.69719",
      "ContentData": "/ContentData/static-1.66838",
      "ContentEditorUI": "/ContentEditorUI/static-2.75704",
      "ContentUtils": "/ContentUtils/static-1.66763",
      "customer-agent-datasources-lib": "/customer-agent-datasources-lib/static-1.5490",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.1698",
      "customer-agent-forms": "/customer-agent-forms/static-1.3484",
      "data-fetching-client": "/data-fetching-client/static-1.9124",
      "editor-components": "/editor-components/static-1.12528",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.37682",
      "foundations-assets": "/foundations-assets/static-1.4301",
      "foundations-components": "/foundations-components/static-1.6982",
      "head-dlb": "/head-dlb/static-1.4465",
      "hs-test-utils": "/hs-test-utils/static-1.7431",
      "hub-http": "/hub-http/static-1.5499",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.8699",
      "hubspot-dlb": "/hubspot-dlb/static-2.1707",
      "HubStyleTokens": "/HubStyleTokens/static-2.10954",
      "I18n": "/I18n/static-7.1469",
      "InpageEditorUI": "/InpageEditorUI/static-1.84144",
      "jasmine-immutable": "/jasmine-immutable/static-1.2417",
      "jasmine-runner": "/jasmine-runner/static-1.5854",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.10466",
      "personalization-lib": "/personalization-lib/static-1.5896",
      "quartz": "/quartz/static-1.6256",
      "react-dlb": "/react-dlb/static-1.64",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.16",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-utils": "/react-utils/static-2.4847",
      "redux-thunk": "/redux-thunk/static-2.43",
      "settings-ui-lib": "/settings-ui-lib/static-1.11965",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4377",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.5092",
      "ui-images": "/ui-images/static-2.983",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.32588",
      "video-components-external": "/video-components-external/static-1.9775",
      "webpack-env": "/webpack-env/static-1.54",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.7557",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.49",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.69",
      "asset-actions-lib": "/asset-actions-lib/static-1.44669",
      "atom": "/atom/static-1.4575",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.25679",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.7093",
      "content-label-lib": "/content-label-lib/static-1.6180",
      "content-management-actions-lib": "/content-management-actions-lib/static-1.26247",
      "content-management-data-lib": "/content-management-data-lib/static-1.4657",
      "content-management-restrictions-lib": "/content-management-restrictions-lib/static-1.4431",
      "copilot-plugins": "/copilot-plugins/static-1.9691",
      "copilot-toolkit": "/copilot-toolkit/static-1.9718",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.621",
      "cta-picker": "/cta-picker/static-1.35149",
      "customer-data-objects": "/customer-data-objects/static-1.7101",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12453",
      "customer-data-properties": "/customer-data-properties/static-1.49882",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.7440",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12540",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9215",
      "data-token-picker": "/data-token-picker/static-1.15533",
      "data-token-views": "/data-token-views/static-1.15514",
      "error-messaging-js": "/error-messaging-js/static-1.4698",
      "feedback-loader": "/feedback-loader/static-1.28231",
      "file-manager-components": "/file-manager-components/static-1.22042",
      "FileManagerCore": "/FileManagerCore/static-1.37541",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.84513",
      "foundations-theming": "/foundations-theming/static-1.3809",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-beacon": "/growth-onboarding-beacon/static-1.4316",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2504",
      "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.924",
      "growth-payments-core": "/growth-payments-core/static-1.23901",
      "history": "/history/static-4.47",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4969",
      "hub-http-contrib": "/hub-http-contrib/static-1.2546",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3531",
      "HubStyle": "/HubStyle/static-2.11262",
      "icons": "/icons/static-2.599",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.13468",
      "integrations-lib": "/integrations-lib/static-1.14573",
      "interframe": "/interframe/static-3.4196",
      "laboratory-lib": "/laboratory-lib/static-3.6612",
      "layout-data-lib": "/layout-data-lib/static-1.8791",
      "media-bridge-lib": "/media-bridge-lib/static-1.18090",
      "nav-meta": "/nav-meta/static-1.28132",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.47042",
      "onboarding-scopes": "/onboarding-scopes/static-1.5961",
      "onboarding-tours": "/onboarding-tours/static-1.15874",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.4088",
      "outpost": "/outpost/static-1.3741",
      "page-lib": "/page-lib/static-1.20965",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.22207",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4488",
      "pictos": "/pictos/static-7.173",
      "PortalIdParser": "/PortalIdParser/static-2.319",
      "products-ui-components": "/products-ui-components/static-1.38491",
      "property-translator": "/property-translator/static-1.4817",
      "quick-fetch": "/quick-fetch/static-1.3468",
      "raven": "/raven/static-3.5386",
      "react": "/react/static-7.151",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.9684",
      "react-dom": "/react-dom/static-7.85",
      "react-flip-move": "/react-flip-move/static-1.59",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.16100",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-tinymce": "/react-tinymce/static-1.53816",
      "react-transition-group": "/react-transition-group/static-1.7",
      "react-virtualized": "/react-virtualized/static-2.86",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.10030",
      "reference-resolvers": "/reference-resolvers/static-1.7658",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7524",
      "reselect": "/reselect/static-2.16",
      "rich-text-lib": "/rich-text-lib/static-1.18870",
      "rpc-client-utils": "/rpc-client-utils/static-1.4136",
      "sanitize": "/sanitize/static-1.3854",
      "sanitize-text": "/sanitize-text/static-1.7602",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "self-service-api": "/self-service-api/static-1.9687",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.175",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1390",
      "simple-menus-core": "/simple-menus-core/static-1.14310",
      "simple-menus-lib": "/simple-menus-lib/static-1.15827",
      "smart-content-lib": "/smart-content-lib/static-1.41706",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.478",
      "superstore": "/superstore/static-1.4178",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.51893",
      "tinymce-config": "/tinymce-config/static-2.52942",
      "tinymce-copilot": "/tinymce-copilot/static-1.15010",
      "tinymce-data": "/tinymce-data/static-1.39027",
      "tinymce-plugins": "/tinymce-plugins/static-1.56056",
      "tinymce-themes": "/tinymce-themes/static-1.54912",
      "transmute": "/transmute/static-2.77",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9376",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10474",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10469",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8367",
      "ui-addon-opt": "/ui-addon-opt/static-4.7928",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4680",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17103",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.8395",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.9709",
      "ui-product-approvals": "/ui-product-approvals/static-1.26602",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9527",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5816",
      "UIComponents": "/UIComponents/static-3.7901",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.3991",
      "usage-tracker": "/usage-tracker/static-1.6851",
      "usage-tracker-core": "/usage-tracker-core/static-1.6701",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4537",
      "user-context": "/user-context/static-1.4609",
      "video-embed": "/video-embed/static-1.34267",
      "web-interactives-components": "/web-interactives-components/static-1.12925",
      "web-interactives-data": "/web-interactives-data/static-1.12926",
      "wootric-nps": "/wootric-nps/static-1.6369",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7096",
      "codemirror": "/codemirror/static-5.84",
      "react-codemirror": "/react-codemirror/static-1.10085",
      "enviro": "/enviro/static-4.345",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4918",
      "raven-hubspot": "/raven-hubspot/static-1.5693",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.9058",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2957",
      "moment": "/moment/static-3.26",
      "chatspot-client-types": "/chatspot-client-types/static-1.10149",
      "chatspot-core": "/chatspot-core/static-1.19279",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.19271",
      "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.1251",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6314",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7408",
      "magpie-lib": "/magpie-lib/static-1.5080",
      "magpie-types": "/magpie-types/static-1.4540",
      "quartz-core": "/quartz-core/static-1.5475",
      "simple-logging-lib": "/simple-logging-lib/static-1.2431",
      "ts-schema": "/ts-schema/static-1.3612",
      "advanced-menus-core": "/advanced-menus-core/static-1.14311",
      "advanced-menus-lib": "/advanced-menus-lib/static-1.11347",
      "avatar-components": "/avatar-components/static-1.1955",
      "cms-field-types": "/cms-field-types/static-1.4172",
      "content-embed-lib": "/content-embed-lib/static-1.6829",
      "ExportDialog": "/ExportDialog/static-6.9913",
      "forms-utils-lib": "/forms-utils-lib/static-1.11535",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.11988",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.11887",
      "products-iframe-lib": "/products-iframe-lib/static-1.6534",
      "react-dnd-compat": "/react-dnd-compat/static-1.4097",
      "usage-tracker-container": "/usage-tracker-container/static-1.6841",
      "video-data-lib": "/video-data-lib/static-1.33433",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.6043",
      "graphql": "/graphql/static-1.71",
      "quartz-config": "/quartz-config/static-1.34",
      "backbone": "/backbone/static-1.6",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.7788",
      "FireAlarmUi": "/FireAlarmUi/static-1.4083",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4269",
      "layout-dnd-components": "/layout-dnd-components/static-1.11491",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1636",
      "smart-content-core": "/smart-content-core/static-1.41054",
      "social-composer-lib": "/social-composer-lib/static-1.56992",
      "structured-content-lib": "/structured-content-lib/static-1.23919",
      "timezone-utils": "/timezone-utils/static-2.4636",
      "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.36731",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8213",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10204",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.12597",
      "ui-tool-access": "/ui-tool-access/static-1.9522",
      "content-icons-ui": "/content-icons-ui/static-1.2036",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6785",
      "final-form": "/final-form/static-1.58",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.16817",
      "prosemirror": "/prosemirror/static-1.13",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1525",
      "directed-graph": "/directed-graph/static-1.363",
      "event-emitter": "/event-emitter/static-1.433",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "react-aria": "/react-aria/static-1.44",
      "audio-components": "/audio-components/static-1.5259",
      "FileManagerImages": "/FileManagerImages/static-1.35193",
      "video-components": "/video-components/static-1.11778",
      "hs-story-utils": "/hs-story-utils/static-1.8814",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3251",
      "floating-ui": "/floating-ui/static-1.45",
      "framer-motion": "/framer-motion/static-1.57",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.335",
      "HeadJS": "/HeadJS/static-2.635",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2542",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.139",
      "i18n-data": "/i18n-data/static-1.211",
      "moment-timezone": "/moment-timezone/static-5.72",
      "jquery": "/jquery/static-3.6",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8664",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.1474",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27107",
      "jasmine": "/jasmine/static-4.3734",
      "marketplace-embed": "/marketplace-embed/static-1.20687",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9029",
      "quartz-core-utils": "/quartz-core-utils/static-1.3123",
      "flux-actions": "/flux-actions/static-1.290",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9908",
      "rxjs": "/rxjs/static-5.10",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4466",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4175",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.10137",
      "content-media-compositions": "/content-media-compositions/static-2.14144",
      "idb-keyval": "/idb-keyval/static-1.33",
      "immerable": "/immerable/static-1.3554",
      "autolinker": "/autolinker/static-3.11",
      "foundations-theming-base": "/foundations-theming-base/static-1.2794",
      "sassPrefix": "/sassPrefix/static-1.145",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.6221",
      "attribution-lib": "/attribution-lib/static-1.41013",
      "crm-message-bus": "/crm-message-bus/static-1.41582",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3562",
      "nudge-client-utils": "/nudge-client-utils/static-1.1751",
      "reporting-ui-components": "/reporting-ui-components/static-2.62642",
      "hubspotter-http": "/hubspotter-http/static-1.4079",
      "ai-rendering-library": "/ai-rendering-library/static-1.8434",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3445",
      "calling-global-api": "/calling-global-api/static-1.62730",
      "calling-internal-common": "/calling-internal-common/static-1.30787",
      "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64112",
      "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.56406",
      "commerce-products-lib": "/commerce-products-lib/static-1.7972",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3382",
      "crm-links": "/crm-links/static-1.5665",
      "external-options-client-types": "/external-options-client-types/static-1.3601",
      "google-libphonenumber": "/google-libphonenumber/static-1.26",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3221",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3688",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3218",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3400",
      "property-value-citations": "/property-value-citations/static-1.496",
      "smart-property-lib": "/smart-property-lib/static-1.4809",
      "tiered-pricing": "/tiered-pricing/static-1.387",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "salesImages": "/salesImages/static-1.514",
      "forms-ai-lib": "/forms-ai-lib/static-1.3440",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2292",
      "embedded-academy-lib": "/embedded-academy-lib/static-1.12707",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5927",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3119",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5103",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7251",
      "ui-universal-auth": "/ui-universal-auth/static-1.8331",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17083",
      "growth-data-modal": "/growth-data-modal/static-1.4742",
      "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.896",
      "navigation-components": "/navigation-components/static-1.16495",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6908",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.5239",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4571",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3131",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17113",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.35678",
      "crm_components": "/crm_components/static-3.90338",
      "crm_data": "/crm_data/static-4.90338",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.37881",
      "customer-data-tracking": "/customer-data-tracking/static-1.6331",
      "dispatcher": "/dispatcher/static-1.125",
      "framework-data-table": "/framework-data-table/static-2.10727",
      "property-description-translator": "/property-description-translator/static-1.3266",
      "csstype": "/csstype/static-1.50",
      "batch-promise": "/batch-promise/static-1.1029",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4091",
      "merchandise-lib": "/merchandise-lib/static-1.245",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9134",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "navigation-messaging": "/navigation-messaging/static-1.5822",
      "feature-store-service-types": "/feature-store-service-types/static-1.4084",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4075",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16201",
      "seo-tools-lib": "/seo-tools-lib/static-1.5895",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "bender-build-tools": "/bender-build-tools/static-1.2623",
      "markdown-it": "/markdown-it/static-1.6",
      "zustand": "/zustand/static-1.51",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3509",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6219",
      "persist-promise": "/persist-promise/static-1.3186",
      "hub-http-janus": "/hub-http-janus/static-1.712",
      "reactive-lib": "/reactive-lib/static-1.179",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.8697",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.408",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.12001",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.20993",
      "knowledge-content-types": "/knowledge-content-types/static-1.8077",
      "social-insights-client-types": "/social-insights-client-types/static-1.20630",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.15564",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.18157",
      "marketplace-ui-details": "/marketplace-ui-details/static-1.8054",
      "property-management-iframe": "/property-management-iframe/static-1.11286",
      "trellis-ecosystem": "/trellis-ecosystem/static-1.6121",
      "hls.js": "/hls.js/static-1.28",
      "js-cookie": "/js-cookie/static-1.18",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.4154",
      "highcharts": "/highcharts/static-8.93",
      "report-customization-components": "/report-customization-components/static-1.11796",
      "reporting-action-components": "/reporting-action-components/static-1.39888",
      "reporting-data": "/reporting-data/static-1.65368",
      "reporting-enablement": "/reporting-enablement/static-1.21181",
      "reporting-snowflake": "/reporting-snowflake/static-1.53988",
      "reporting-visualizations": "/reporting-visualizations/static-1.57445",
      "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.1507",
      "nudge-renderer-utils": "/nudge-renderer-utils/static-1.1826",
      "whisper-core-api": "/whisper-core-api/static-1.5180",
      "reporting-plugins": "/reporting-plugins/static-1.9482",
      "reporting-reports": "/reporting-reports/static-1.65048",
      "highlight.js": "/highlight.js/static-1.68",
      "ui-addon-teams": "/ui-addon-teams/static-1.20824",
      "calling-error-reporting": "/calling-error-reporting/static-1.30793",
      "shared-worker-versioning": "/shared-worker-versioning/static-1.10516",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5958",
      "calling-orchestration-shared-library": "/calling-orchestration-shared-library/static-1.33924",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9081",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.7665",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.4833",
      "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.8782",
      "fsm": "/fsm/static-1.3145",
      "policy-lib": "/policy-lib/static-1.6218",
      "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.8845",
      "academy-common-lib": "/academy-common-lib/static-1.12167",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2497",
      "customer-data-associations": "/customer-data-associations/static-1.6702",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.17686",
      "crm_universal": "/crm_universal/static-1.21265",
      "customer-data-content": "/customer-data-content/static-1.26253",
      "crm_schema": "/crm_schema/static-3.90377",
      "customer-data-email": "/customer-data-email/static-1.17078",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.20315",
      "lodash": "/lodash/static-4.7",
      "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.482",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12145",
      "deal-intel-decorators": "/deal-intel-decorators/static-1.347",
      "tanstack-virtual": "/tanstack-virtual/static-1.19",
      "customer-data-rte": "/customer-data-rte/static-1.31753",
      "cv-backend-services": "/cv-backend-services/static-1.1380",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.4972",
      "qrcode-generator": "/qrcode-generator/static-1.57",
      "quotes-client-types": "/quotes-client-types/static-1.36279",
      "trials-service-types": "/trials-service-types/static-1.3492",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7219",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.16691",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.6637",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6881",
      "immutable-less": "/immutable-less/static-1.4004",
      "react-window": "/react-window/static-1.13",
      "ai-studio-lib": "/ai-studio-lib/static-1.10188",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.9844",
      "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18114",
      "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.12329",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7477",
      "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7252",
      "property-management-common": "/property-management-common/static-1.3573",
      "storybook-react": "/storybook-react/static-1.20",
      "trellis-story-utils": "/trellis-story-utils/static-1.3991",
      "dashboard-lib": "/dashboard-lib/static-1.79505",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8148",
      "reporting-client-types": "/reporting-client-types/static-1.2265",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.11598",
      "html-to-image": "/html-to-image/static-1.42",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.7402",
      "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34149",
      "sales-views-client-types": "/sales-views-client-types/static-1.3705",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3149",
      "academy-service-client": "/academy-service-client/static-1.3096",
      "utility-belt": "/utility-belt/static-1.1927",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8311",
      "sequences-lib": "/sequences-lib/static-1.7245",
      "deal-intel-utils": "/deal-intel-utils/static-1.351",
      "draft-content-plugins": "/draft-content-plugins/static-1.27130",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-plugins": "/draft-plugins/static-2.20736",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3469",
      "stripe-connect-js": "/stripe-connect-js/static-1.43",
      "knowledge-box": "/knowledge-box/static-1.6294",
      "apps-service-types": "/apps-service-types/static-1.3421",
      "oauth-service-types": "/oauth-service-types/static-1.3687",
      "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14059",
      "crm-component-utils": "/crm-component-utils/static-1.37736",
      "redux-actions": "/redux-actions/static-3.7",
      "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3688",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7102",
      "card-properties-lib": "/card-properties-lib/static-1.42727",
      "crm-actions": "/crm-actions/static-1.5665",
      "crm-cards-data": "/crm-cards-data/static-1.569",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.42071",
      "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8026",
      "customer-data-sidebar": "/customer-data-sidebar/static-2.44592",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.13927",
      "crm-fe-perf": "/crm-fe-perf/static-1.22413",
      "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.35723",
      "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38101",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.10252",
      "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53120",
      "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20241",
      "products-highlight-card-lib": "/products-highlight-card-lib/static-1.16256",
      "project-storage": "/project-storage/static-1.4109",
      "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.70193",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.4749",
      "quotes-ui-lib": "/quotes-ui-lib/static-1.78910",
      "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6152",
      "invoices-ui-lib": "/invoices-ui-lib/static-1.53136",
      "commerce-products-api": "/commerce-products-api/static-1.1427",
      "SafeStorage": "/SafeStorage/static-1.3796",
      "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55194",
      "quotes-modal-lib": "/quotes-modal-lib/static-1.100867",
      "totals-ui-components": "/totals-ui-components/static-1.22174",
      "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3327"
    },
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};